import React, { ReactElement } from 'react'
import { IColorTheme, SelectedPrice } from '../../types/itemTypes'
import { StateAction } from '../../types/typeAliases'
import { BuyButton } from './ItemButtonStyles'

type Props = {
  soldOutOrInvalid: boolean
  colorTheme: IColorTheme
  showPrices: boolean
  setShowPrices: StateAction<boolean>
  showDetails: boolean
  buyPrices: () => void
  resetPricesSelected: () => void
  pricesSelected: SelectedPrice[]
  noActivePrices: boolean
}
export default function ShowPricesButton(props: Props): ReactElement {
  const {
    soldOutOrInvalid,
    colorTheme,
    showPrices,
    setShowPrices,
    showDetails,
    buyPrices,
    resetPricesSelected,
    pricesSelected,
    noActivePrices,
  } = props

  const noPricesSelected = showPrices
    && pricesSelected.reduce((total, { count }) => total + count, 0) === 0

  const getLabel = (): string | ReactElement => {
    if (soldOutOrInvalid) return 'Sold out'

    if (showPrices) {
      return (
        <span style={{ display: 'flex' }}>
          Buy
          <div className="buy-button-chevron" />
        </span>
      )
    }

    return (
      <span style={{ display: 'flex' }}>
        Select
        <div className="buy-button-chevron" />
      </span>
    )
  }

  const getClass = (): string => {
    if (showDetails || noPricesSelected || noActivePrices) { return 'select-button-disabled' }
    if (soldOutOrInvalid) return 'sold-out'
    return ''
  }

  const handleClick = (): void => {
    if (!showPrices) {
      setShowPrices(true)
    } else {
      buyPrices()
      resetPricesSelected()
    }
  }

  return (
    <BuyButton
      onClick={handleClick}
      disabled={
        (soldOutOrInvalid && !showPrices)
        || showDetails
        || noPricesSelected
        || noActivePrices
      }
      className={getClass()}
      theme={colorTheme}
    >
      {getLabel()}
    </BuyButton>
  )
}
